import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { toBase64String } from '@angular/compiler/src/output/source_map';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ResponsibleService {

  constructor(private _utilsService: UtilsService) { 
  }

  voluntaryExclusion(user_id,length,password){
    password = btoa(password); //base64 encode
    return this._utilsService.postRequest(`${environment.phpApiUrl}/users/exclusion`, {user_id,length,password}, null, 'content-type-json');
  }

  depositLimit(user_id,amount,length,password){
    password = btoa(password); //base64 encode
    return this._utilsService.postRequest(`${environment.phpApiUrl}/users/depositLimit`, {user_id,amount,length,password}, null, 'content-type-json');
  }

  private handleErrorPost<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(result); // log to console instead 
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
